module.exports = __webpack_public_path__ + "img/us.02911529.png";